import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { queryCache } from '@office-start/data-fetching';
import { fetchIdentity } from '@office-start/identity-service';
import { fetchConfigInternal } from '../fetchConfigInternal';
import { defaultPrefetchOptions } from '../models/defaultPrefetchOptions';
/**
 * Generic function which can be used to access office-start's configuration data via ReactQuery cache.
 */
export function fetchConfig(options) {
    return __awaiter(this, void 0, void 0, function () {
        var key, queryKey;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = options.key;
                    queryKey = [key];
                    return [4 /*yield*/, queryCache.fetchQuery(queryKey, function () {
                            var fetchDataPromisesObject = {
                                contextPromise: fetchOfficeComponentContext(),
                                identityPromise: fetchIdentity(),
                            };
                            return fetchConfigInternal(fetchDataPromisesObject, options);
                        }, defaultPrefetchOptions)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=fetchConfig.js.map